export const pricingPlans = [
  {
    name: 'Starter',
    description: 'Entry level for small providers.',
    monthly: {
      price: '$54.99',
      period: '/month',
    },
    yearly: {
      price: '$593.89',
      period: '/year ($49.49/mo)',
    },
    features: [
      '1 Facility',
      '4 staff members',
      '4 Clients',
      'Medication Management/eMAR',
      'Care Plans',
      'Client Intake',
      'Custom Roles',
      'Document Management',
      'Staff Management',
      'Text to Speech',
      'Unlimited Notes',
      'Unlimited Reports',
      'Clock In/Clock Out',
      "Invoice",
      'EVV',
      'SkAI (100 queries)',
      '14 days free trial',
    ],
    buttonText: 'Get started',
    buttonVariant: 'black',
  },
  {
    name: 'Bronze',
    description: 'Perfect for growing agencies.',
    monthly: {
      price: '$149.99',
      period: '/month',
    },
    yearly: {
      price: '$1619.89',
      period: '/year ($134.99/mo)',
    },
    features: [
      'Unlimited Facilities',
      '12 staff members (Add. +$15)',
      '10 Clients (Add. +$20)',
      'Medication Management/eMAR',
      'Care Plans',
      'Client Intake',
      'Custom Roles',
      'Document Management',
      'Staff Management',
      'Text to Speech',
      'Unlimited Notes',
      'Unlimited Reports',
      'Clock In/Clock Out',
      'Invoice',
      'SkAI (100 queries)',
      'EVV',
      '14 days free trial',
    ],
    buttonText: 'Get started',
    buttonVariant: 'yellow',
    isPopular: true,
  },
  {
    name: 'Silver',
    description: 'For scaling teams with billing needs.',
    monthly: {
      price: '$299.99',
      period: '/month',
    },
    yearly: {
      price: '$3239.89',
      period: '/year ($269.99/mo)',
    },
    features: [
      'Unlimited Facilities',
      '25 staff members (Add. +$10)',
      '22 Clients (Add. +$15)',
      'Medication Management/eMAR',
      'Care Plans',
      'Client Intake',
      'Custom Roles',
      'Document Management',
      'Staff Management',
      'Text to Speech',
      'Unlimited Notes',
      'Unlimited Reports',
      'Clock In/Clock Out',
      'Invoice',
      'Includes Billing features',
      'SkAI (300 queries)',
      'EVV',
      'Scheduler (coming soon)',
      '14 days free trial',
    ],
    buttonText: 'Get started',
    buttonVariant: 'black',
  },
  {
    name: 'Gold',
    description: 'Comprehensive solution for large facilities.',
    monthly: {
      price: '$549.99',
      period: '/month',
    },
    yearly: {
      price: '$5939.89',
      period: '/year ($494.99/mo)',
    },
    features: [
      'Unlimited Facilities',
      '55 staff members (Add. +$3)',
      '48 Clients (Add. +$10)',
      'Medication Management/eMAR',
      'Care Plans',
      'Client Intake',
      'Custom Roles',
      'Document Management',
      'Staff Management',
      'Text to Speech',
      'Unlimited Notes',
      'Unlimited Reports',
      'Clock In/Clock Out',
      'Invoice',
      'Includes Billing features',
      'SkAI (Unlimited queries)',
      'EVV',
      'Scheduler (coming soon)',
      '14 days free trial',
    ],
    buttonText: 'Get started',
    buttonVariant: 'black',
  },
];

export const comparisonColumns = pricingPlans.map((plan) => plan.name);

export const comparisonFeatures = [
  {
    category: 'Core Features',
    items: [
      { name: 'Facilities', values: ['1 Facility', 'Unlimited', 'Unlimited', 'Unlimited'] },
      { name: 'Staff Members', values: ['4 staff', '12 staff', '25 staff', '55 staff'] },
      { name: 'Clients', values: ['4 Clients', '10 Clients', '22 Clients', '48 Clients'] },
      { name: 'SkAI Queries', values: ['100', '100', '300', 'Unlimited'] },
      { name: 'Medication Management/eMAR', values: [true, true, true, true] },
    ],
  },
  {
    category: 'Management & Billing',
    items: [
      { name: 'Clock In/Clock Out & Invoice', values: [true, true, true, true] },
      { name: 'Notes & Reports', values: ['Unlimited', 'Unlimited', 'Unlimited', 'Unlimited'] },
      { name: 'Billing Features', values: [false, false, true, true] },
      { name: 'Scheduler', values: [false, false, 'Coming soon', 'Coming soon'] },
      { name: 'EVV', values: [false, 'Paid', 'Paid', 'Paid'] },
    ],
  },
  {
    category: 'Support',
    items: [
      { name: 'Free Trial', values: ['14 Days', '14 Days', '14 Days', '14 Days'] },
      { name: 'Support Level', values: ['Standard', 'Priority', 'Priority', 'Dedicated'] },
    ],
  },
];

export const faqItems = [
  {
    title: 'Are there any training and/or onboarding fees?',
    content:
      'Absolutely no training or onboarding fees. Ogiso is a subscription based platform, which means that you are only billed on a monthly basis depending on your subscription tier.',
  },
  {
    title: 'What types of healthcare businesses can use Ogiso?',
    content:
      "Ogiso's platform is a comprehensive documentation and compliance solution designed specifically for HCBS (Home and Community-Based Services) providers. It streamlines documentation, improves compliance management, and enhances the overall efficiency of care services through a user-friendly digital platform.",
  },
  {
    title: 'How does Ogiso improve documentation for HCBS providers?',
    content:
      'Ogiso replaces outdated methods like handwritten notes or Word documents with a cloud-based platform that automates record-keeping, ensures real-time updates, and enhances collaboration. This allows providers to focus more on client care and less on paperwork.',
  },
  {
    title: 'Is Ogiso compliant with industry regulations?',
    content:
      "Yes, Ogiso's platform is designed to meet all relevant industry standards and regulatory requirements, ensuring that your documentation remains compliant with state and federal guidelines for HCBS providers.",
  },
  {
    title: "Can I customize the platform to fit my organization's needs?",
    content:
      "Absolutely. Ogiso offers customizable features that allow you to tailor the documentation process according to your organization's specific workflow and compliance requirements.",
  },
  {
    title: "How secure is the data stored on Ogiso's platform?",
    content:
      'Ogiso uses advanced encryption and security protocols to ensure that all data is stored securely. We are fully HIPAA-compliant, providing peace of mind that your sensitive information is protected.',
  },
  {
    title: 'Is there any contract?',
    content:
      'There are NO contracts associated with your Ogiso subscription. You can cancel anytime directly from your dashboard.',
  },
];
